export default {
  menu: 'Service',
  title: 'Service',

  general: {
    labels: {
      type: 'Type',
      id: 'Id',
      barcode: 'Barcode',
      url: 'Url',
      productName: 'Title',
      serviceName: 'Title',
      category: 'Category',
      serviceCategory: 'Category',
      price: 'Price',
      productPrice: 'Product Price',
      servicePrice: 'Service Price',
      salePrice: 'Sale price',
      saleStartDate: 'Auction start date',
      saleEndDate: 'Auction end date',
      maxSelect: 'Maximum number of selections',
      description: 'Description',
      inventory: 'Inventory',
      chooseAttribute: 'select attribute',
      chooseCategory: 'select category',
      withoutCategory: 'without category',
      removeService: 'remove Service',
      createVariable: 'create a new variable',
      removeVariable: 'remove variable'
    },

    notifications: {
      insert: {
        success: 'Service information was successfully registered',
        error: 'Registration of service information encountered an error'
      },
      edit: {
        success: 'Service information successfully edited',
        error: 'Edit Service information encountered an error'
      },
      delete: {
        success: 'Service information successfully deleted',
        error: 'Deleting service information was accompanied by an error',
        isUsed: 'Due to the existence of the document, this service cannot be deleted'
      },
      restore: {
        success: 'Service returned successfully',
        error: 'Delivery returned failed'
      }
    },

    confirmations: {
      delete: {
        title: 'Confirmation',
        body: 'Are you sure you want to delete this item? If confirmed, service information will also be removed from your store! '
      },
      forceDelete: {
        title: 'Confirmation of deletion of service',
        body: 'Are you sure you want to delete {name} permanently?'
      }
    },

    validators: {
      dateHelp: 'The entry must be entered as {date}.',
      wrongInputValues: 'The information entered is incorrect',
      imageSize: 'The selected file size is too large',
      fileFormat: 'The selected file format is not allowed',
      variantExist: 'There is a variable with this feature',
      variantListTotalCount: 'The total number of possible modes is {max}',
      salePrice: 'The sale price could not be higher than the original price',
      variableSalePrice: 'Variable sale price with barcode {barcode} could not be higher than the original price',
      title: 'There is a service with this name or the name is not entered correctly',
      code: 'There is a service with this code or the code is wrong',
      barcode: 'There is a service with this barcode or the barcode is wrong',
      variableBarcode: 'Row variable barcode {row} is duplicate'
    },

    dataCategory: {
      generalInfo: 'General Information'
    }
  },

  list: {
    title: 'Services',

    table: {
      header: {
        row: 'Row',
        name: 'Name',
        code: 'Code',
        barcode: 'Barcode',
        price: 'Price',
        image: 'Image',
        category: 'Category',
        creator: 'Creator',
        lastModifiedDate: 'Last modified'
      },

      filters: {
        status: {
          all: 'All',
          notConnect: 'No connection',
          draft: 'Draft',
          waiting: 'Waiting',
          published: 'Published',
          personal: 'Personal'
        },

        type: {
          all: 'All',
          simpleProduct: 'Simple service',
          variableProduct: 'Variable service'
        }
      }
    }
  },

  insert: {
    title: 'Insert service',

    labels: {
      importData: 'Upload service opening balance file'
    },

    types: {
      label: 'Select insert type',
      useral: 'Insert to Useral',
      woocommerce: 'Insert to {shopName} and Useral'
    },

    table: {
      header: {
        inventory: 'Inventory',
        barcode: 'Barcode',
        price: 'Price',
        salePrice: 'Sale price',
        delete: 'Delete'
      }
    },

    description: {
      title: 'Note',

      useralDescription: 'The information of this service is registered only in the useral system.',
      woocommerceDescription: 'Service information is recorded directly in your store under review status.',
      notCategorySelected: 'No categories selected',
      noAttributesExistForCategory: 'There are no attributes for this category',
      noAttributeChooseForVariables: 'No attribute selected as variable',
      inventory: 'On this page you can enter the entire product inventory. If the number of inventories is zero, the product will be considered non-existent. ',
      attribute: 'You can select the Attributes you want and add it to the service Attributes list. If the service is a variable type, you can select {bold} of the Attributes as the service variable attribute ',
      attributeBold: ' one '
    },

    accordionList: {
      brand: {
        title: 'Select the desired brand',

        insert: {
          title: 'Add a new brand',
          brand: 'brand title'
        },

        edit: {
          title: 'Edit Brand',
          category: 'Brand Title'
        },

        delete: {
          title: 'Delete Brand',
          message: 'By deleting this brand, all related information will also be deleted.'
        }
      },

      category: {
        title: 'Select the desired category',

        insert: {
          title: 'Add new category',
          category: 'Category Title'
        },

        edit: {
          title: 'Edit Category',
          category: 'Category Title'
        },

        delete: {
          title: 'Delete Category',
          message: 'Deleting this category will delete all related information.'
        }
      },


      attributes: 'Properties',
      insertAttribute: {
        title: 'Add new feature',
        attribute: 'attribute title',
        values: 'values'
      },
      editAttribute: {
        title: 'Edit Feature',
        attribute: 'attribute title',
        values: 'values'
      },

      buttons: {
        accept: 'Confirm',
        cancel: 'Cancel'
      },

      alert: {
        title: 'Message',
        brandCreated: 'Brand created successfully',
        brandUpdated: 'Brand successfully edited',
        brandDeleted: 'Brand successfully deleted',
        categoryCreated: 'Category created successfully',
        categoryUpdated: 'Category edited successfully',
        categoryDeleted: 'Category deleted successfully',
        errorTitle: 'error',
        error: 'The process went wrong'
      }
    }
  },

  edit: {
    title: 'Edit service',
    dynamicTitle: 'Edit {name}',

    table: {
      header: {
        inventory: 'Inventory',
        barcode: 'Barcode',
        price: 'Price',
        salePrice: 'Sale price',
        delete: 'Delete'
      }
    },

    description: {
      title: 'Description',

      variableDescription: 'You can edit information about each variable in your store through this page.',
      useralDescription: 'The information of this service is registered only in the useral system.',
      woocommerceDescription: 'Service information is recorded directly in your store under review status.',
      notCategorySelected: 'No categories selected',
      noAttributesExist: 'There are no attributes for this category',
      noAttributeChooseForVariables: 'No attribute selected as variable',
      inventory: 'On this page you can enter the entire service inventory. If the number of inventories is zero, the service will be considered non-existent. ',
      attribute: 'You can select the Attributes you want and add it to the service Attributes list. If the service is a variable type, you can select {bold} of the Attributes as the service variable attribute ',
      attributeBold: ' one '
    }
  },

  service: {
    title: 'Service',

    general: {
      importantData: {
        price: 'Price',
        salePrice: 'Sale price',
        category: 'Category'
      },

      actions: {
        logs: 'Time lines'
      }
    },

    logs: {
      title: 'Service logs'
    }
  },

  select: {
    title: 'Services list',

    table: {
      header: {
        select: 'Select',
        rowNumber: 'row',
        name: 'Title',
        code: 'Code',
        barcode: 'Barcode',
        price: 'Price',
        image: 'Photo',
        category: 'Category',
        type: 'type',
        variant: 'variable',
        salePrice: 'Sale price',
        quantity: 'Inventory',
        storeroom: 'warehouse',
        edit: 'edit'
      },

      filters: {
        type: {
          all: 'All',
          simple: 'simple',
          variant: 'Variable'
        }
      }
    }
  },

  trash: {
    title: 'Removed services',

    table: {
      header: {
        rowNumber: 'Row',
        name: 'Title',
        code: 'Code',
        image: 'Image',
        type: 'Type',
        price: 'Price',
        delete: 'Delete',
        restore: 'Restore'
      }
    }
  }
}
